// custom error types to pass to `logError` for better tracking/debugging
export const REQUEST_TIMEOUT = 'RequestTimeout';
export const VALIDATION_ERROR = 'ValidationError';
